<template>
  <DataLayout
    class="DataItemText"
    :title="title"
    :sub-title="subTitle"
    :is-dl="isDl"
    :information="information"
    :information-label="informationLabel"
    :show-information="showInformation"
    :instructions="instructions"
    :instruction-id="instructionId"
  >
    <v-text-field
      ref="focusId"
      :value="model"
      :error="hasError()"
      :error-messages="extractError()"
      :placeholder="placeholder"
      outlined
      single-line
      :aria-label="ariaLabel"
      :autocomplete="autocomplete"
      :required="isRequired"
      :aria-required="isRequired"
      :hide-details="hideDetails"
      :aria-describedby="instructionId"
      @click="clicked"
      @focus="focused"
      @blur="blured"
      @input="sanitizeAndUpdateInput"
      @paste="pasteInput"
    ></v-text-field>
  </DataLayout>
</template>

<script>
import hasError from "~/components/forms/utilities/hasError";
import extractError from "~/components/forms/utilities/extractError";

import DataLayout from "~/components/forms/components/layout/DataLayout";
import {
  sanitizeAndUpdateInput,
  pasteInput,
} from "~/components/forms/utilities/sanitizeCharacterInput";

export default {
  name: "DataItemText",
  components: {
    DataLayout,
  },
  props: {
    item: { type: Object, default: () => {} },
    fieldName: { type: String, required: true },
    updateAction: { type: String, default: () => undefined },
    isRequired: { type: Boolean, default: false },
    setFocus: { type: Boolean, default: false },

    errors: { type: Array, default: () => [] },
    instructionId: { type: String, default: null },
    instructions: { type: String, default: "" },

    title: { type: String, default: "" },
    subTitle: { type: String, default: "" },
    isDl: { type: Boolean, default: false },
    label: { type: String, default: "" },
    information: { type: String, default: undefined },
    informationLabel: { type: String, default: undefined },
    autocomplete: { type: String, default: "" },

    index: { type: Number, default: undefined },
    hideDetails: { type: Boolean, default: false },

    placeholder: { type: String, default: undefined },

    trimValue: { type: Boolean, default: undefined },

    sanitizeCharacterInput: { type: Boolean, default: false },
  },
  data() {
    return {
      wasClicked: undefined,
      wasFocused: undefined,
      isShown: undefined,
      model: "",
      pastedText: null,
    };
  },
  computed: {
    ariaLabel() {
      return this.title ? this.title.toLowerCase() : undefined;
    },
    showInformation() {
      return this.isShown && !!this.information;
    },
  },
  mounted() {
    this.model = this.item?.[this.fieldName] || null;
    if (this.setFocus) {
      this.$refs.focusId.focus();
    }
  },
  methods: {
    hasError,
    extractError,
    sanitizeAndUpdateInput,
    pasteInput,
    clicked() {
      this.wasClicked = true;
    },
    focused() {
      this.wasFocused = true;

      if (this.information) {
        setTimeout(() => {
          if (this.wasClicked === undefined && this.wasFocused === true) {
            this.isShown = true;
          }
        }, 500);
      }
    },
    blured() {
      this.wasClicked = undefined;
      this.wasFocused = undefined;
      this.isShown = false;
    },
  },
};
</script>
